import { IncentivesForm } from "./IncentivesForm";

export function IncentivesFormPage() {
  return <IncentivesForm />;
}
